export const SET_ALL = 'programs/SET_ALL';
export const SET_BY_ID = 'programs/SET_BY_ID';
